<template>
  <div class="u-containar-md registerForm">
    <HeadingLv2
      text="マイナビRESIDENT サイト引継ぎ利用登録<br />2020年11月以前にマイナビRESIDENTをご利用の方へ"
      simple
    />
    <router-view :data="data" @update-profile="updateProfile"></router-view>
  </div>
</template>

<script lang="ts">
import { reactive } from 'vue'
import HeadingLv2 from '@/components/elements/HeadingLv2.vue'

export default {
  name: 'Form',

  components: {
    HeadingLv2
  },

  setup() {
    const data = reactive<any>({
      email: '',
      password: '',
      password_confirmation: '',
      token: ''
    })

    const updateProfile = (name: string, value: string) => {
      data[name] = value
    }

    return {
      data,
      updateProfile
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.registerForm {
  padding-bottom: 160px;
}
</style>
